<template>
  <v-icon
    small
    class="mr-2"
    color="blue"
    @click="showDetails"
    style="padding: 10%"
  >
    mdi-plus-circle
  </v-icon>
</template>

<script>
export default {
  name: 'CreditMoreDetails',
  methods: {
    showDetails() {
      this.params.context.componentParent.showCreditDetails(this.params.data);
    }
  }
};
</script>

<style scoped>

</style>
